import { DeviceSettingsActions } from '@account-settings/redux/deviceSettings/deviceSettingsActions';
import { DEVICE_SETTINGS_ACTIONS, IDeviceSettingsState, IMobileDeviceWithUser } from '@account-settings/redux/deviceSettings/deviceSettingsModel';

const initialState: IDeviceSettingsState = {
  mobileDevices: [],
  flags: {
    isFetchingMobileDevices: false,
    isUpdatingDeviceName: false,
  },
};

export default function DeviceSettingsReducer(
  state: IDeviceSettingsState = initialState,
  action: DeviceSettingsActions
): IDeviceSettingsState {
  switch (action.type) {
    case DEVICE_SETTINGS_ACTIONS.REQUEST_MOBILE_DEVICES:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingMobileDevices: true,
        },
      };
    case DEVICE_SETTINGS_ACTIONS.RECEIVE_MOBILE_DEVICES_SUCCEEDED:
      return {
        ...state,
        mobileDevices: action.mobileDevices,
        flags: {
          ...state.flags,
          isFetchingMobileDevices: false,
        },
      };
    case DEVICE_SETTINGS_ACTIONS.RECEIVE_MOBILE_DEVICES_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingMobileDevices: false,
        },
      };
    case DEVICE_SETTINGS_ACTIONS.MOBILE_DEVICE_REMOVED:
      return {
        ...state,
        mobileDevices: state.mobileDevices.filter((d: IMobileDeviceWithUser) => d.id !== action.deviceId),
      };
    case DEVICE_SETTINGS_ACTIONS.REQUEST_RENAME_DEVICE:
      return {
        ...state,
        flags: {
          ...state.flags,
          isUpdatingDeviceName: true,
        },
      };
    case DEVICE_SETTINGS_ACTIONS.RECEIVE_RENAME_DEVICE_SUCCEEDED:
      return {
        ...state,
        mobileDevices: state.mobileDevices.map(
          (d: IMobileDeviceWithUser) => ({
            ...d,
            name: d.id === action.deviceId ? action.name : d.name,
          }),
        ),
        flags: {
          ...state.flags,
          isUpdatingDeviceName: false,
        },
      };
    case DEVICE_SETTINGS_ACTIONS.RECEIVE_RENAME_DEVICE_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isUpdatingDeviceName: false,
        },
      };
    default:
      return state;
  }
}
